import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80%;
    gap: 10px;
    border-radius: 10px;
    padding-block: 5px;
    background: #F2F2F2;
`;

export const OutButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 7px;
    width: 30px;
    height: 30px;
    border-radius: 15px;
    color: #FF3939;
    border: 0.743px solid #FF3939;
    background: transparent;
    font-weight: 900;
    line-height: normal;
    cursor: pointer;
    outline: none;
    transition: 1s;
    &:hover {
        background: #FF3939;
        color: #fff;
    }
`;

export const NameContainer = styled.div`
    display: flex;
    align-items: center;
    width: 55%;
    margin-left: 40px;
`;

export const ValuesContainer = styled.div`
    display: flex;
    align-items: center;
    width: 50px;
`;

export const ArrowContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
`;

export const ArrowIMG = styled.img`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const NameText = styled.span`
    color: #333;
    leading-trim: both;
    text-edge: cap;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

export const OldValueText = styled.span`
    color: #3C9;
    leading-trim: both;
    text-edge: cap;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
`;

export const TotalContainer = styled.div`
    display: flex;
    justify-content: center;
    background: #3C9;
    border-radius: 50%;
    padding: 2px;
`

export const NewValueText = styled.span`
    min-width: 18px;
    flex-direction: column;
    flex-shrink: 0;
    color: #F6F6F6;
    text-align: center;
    leading-trim: both;
    text-edge: cap;
    font-size: 15.55px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;